import { FEATURE_FLAG_KEYS } from '@alpha-core/feature-flags/feature-flag.constants';
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { FeatureFlagsService } from '@neutrinos/ngx-feature-flags';
import { BranchStateService } from '../services/branch-state.service';

export const branchGuard: CanActivateFn = (route, state): boolean | UrlTree => {
    const router = inject(Router);
    const branchStateService = inject(BranchStateService);
    const featureFlagsService = inject(FeatureFlagsService);

    const changeTrackingEnabled = featureFlagsService.isFeatureEnabled(FEATURE_FLAG_KEYS.CHANGE_TRACKING);
    const branch = route.queryParams['branch'];
    const projectId = route.params['projectId'];

    if (!changeTrackingEnabled) {
        // Remove branch param when change tracking is disabled
        if (branch) {
            const urlTree = router.parseUrl(state.url);
            delete urlTree.queryParams['branch'];
            return urlTree;
        }
        return true;
    }

    // Existing logic for when change tracking is enabled
    if (!branch) {
        // Try to restore from localStorage, fallback to 'main'
        const savedBranch = branchStateService.loadBranch(projectId);
        const targetBranch = savedBranch || 'main';

        const urlTree = router.parseUrl(state.url);
        urlTree.queryParams = { ...urlTree.queryParams, branch: targetBranch };
        return urlTree;
    }
    return true;
};
